// Module
var code = "<div> <!-- ko foreach: SubForms --> <!-- ko template: { name: GetTemplateName.bind($rawData), afterRender: $rawData.AfterRender.bind($rawData) } --><!-- /ko --> <!-- /ko --> </div> ";
// Exports
export default code;